module.exports = __webpack_public_path__ + "static/media/lt-image.b6ca1017.png";